import React, { useState } from "react";

// @material-ui/core customComponents
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
// custom components
import CustomInputAdapter from "../components/CustomInputAdapter";

import modalStyle from "assets/jss/material-kit-pro-react/modalStyle";
import PropTypes from "prop-types";
import { Form, FormSpy } from "react-final-form";
import arrayMutators from "final-form-arrays";
import FieldAdapter from "../components/FieldAdapter";
import { getLocationAsGeoData } from "../../../utils/Utils";
import { observer } from "mobx-react";
import MapComponent from "../../Map/Map";

const style = (theme) => ({
	...modalStyle(theme),
	modalRootExample: {
		"& > div:first-child": {
			display: "none",
		},
		backgroundColor: "rgba(0, 0, 0, 0.5)",
	},
	removeButton: {
		display: "flex",
		justifyContent: "flex-end",
	},
});

// eslint-disable-next-line react/display-name
const Transition = React.forwardRef((props, ref) => (
	<Slide direction="down" ref={ref} {...props} />
));

const LocationModal = observer((props) => {
	const [open, setOpen] = useState(false);
	const [geoCoordinates, setGeoCoordinates] = useState();

	const onSubmit = async (values) => {
		const { onSubmit } = props;

		onSubmit({ ...values, geoCoordinates });
		handleClose();
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const { classes, location, button } = props;

	return (
		<div>
			{button(() => {
				handleClickOpen();
			})}
			{open && (
				<Dialog
					classes={{
						root: `${classes.modalRoot} ${classes.modalRootExample}`,
						paper: `${classes.modal} ${classes.modalLarge}`,
					}}
					open={open}
					TransitionComponent={Transition}
					keepMounted
					onClose={() => handleClose()}
					aria-labelledby="classic-modal-slide-title"
					aria-describedby="classic-modal-slide-description"
				>
					<Form
						onSubmit={onSubmit}
						initialValues={location}
						mutators={{ ...arrayMutators }}
						render={({ handleSubmit, form, submitting, pristine, values }) => (
							<form onSubmit={handleSubmit}>
								<FormSpy
									subscription={{ values: true }}
									onChange={async ({ values }) => {
										const geoData = await getLocationAsGeoData(values);
										setGeoCoordinates(geoData);
									}}
								/>

								<DialogTitle
									id="classic-modal-slide-title"
									disableTypography
									className={classes.modalHeader}
								>
									<Button
										simple
										className={classes.modalCloseButton}
										key="close"
										aria-label="Close"
										onClick={() => handleClose()}
									>
										{" "}
										<Close className={classes.modalClose} />
									</Button>
									<h4 className={classes.modalTitle}>
										{values.name ? values.name : "Neue Sportstätte"}
									</h4>
								</DialogTitle>
								<DialogContent
									id="classic-modal-slide-description"
									className={classes.modalBody}
								>
									<GridContainer>
										<GridItem xs={12} sm={12} md={12} lg={12}>
											<h4>Sportstätte</h4>
										</GridItem>
										<GridItem xs={12} sm={12} md={12} lg={12}>
											<FieldAdapter
												name="name"
												component={CustomInputAdapter}
												type="text"
												placeholder="Name"
												label="Name"
												validate={(value) => !value && "Eingabe erforderlich"}
											/>
										</GridItem>
										<GridItem xs={12} sm={8} md={8} lg={8}>
											<FieldAdapter
												name="street"
												component={CustomInputAdapter}
												type="text"
												placeholder="Straße"
												label="Straße"
											/>
										</GridItem>
										<GridItem xs={12} sm={4} md={4} lg={4}>
											<FieldAdapter
												name="houseNumber"
												component={CustomInputAdapter}
												type="text"
												placeholder="Hausnummer"
												label="Hausnummer"
											/>
										</GridItem>
										<GridItem xs={12} sm={4} md={4} lg={4}>
											<FieldAdapter
												name="zipCode"
												component={CustomInputAdapter}
												type="text"
												placeholder="Postleitzahl"
												label="Postleitzahl"
											/>
										</GridItem>
										<GridItem xs={12} sm={8} md={8} lg={8}>
											<FieldAdapter
												name="city"
												component={CustomInputAdapter}
												type="text"
												placeholder="Ort"
												label="Ort"
											/>
										</GridItem>
										<GridItem>
											<MapComponent
												coordinates={geoCoordinates ? [geoCoordinates] : null}
												initialViewState={{ ...geoCoordinates, zoom: 10 }}
											/>
										</GridItem>
									</GridContainer>
								</DialogContent>
								<DialogActions className={classes.modalFooter}>
									<Button
										onClick={form.reset}
										disabled={submitting || pristine}
										color="secondary"
									>
										Zurücksetzen
									</Button>
									<Button color="primary" type="submit" disabled={submitting}>
										Speichern
									</Button>
								</DialogActions>
							</form>
						)}
					/>
				</Dialog>
			)}
		</div>
	);
});

LocationModal.propTypes = {
	classes: PropTypes.object,
	onSubmit: PropTypes.func,
	location: PropTypes.object,
	button: PropTypes.func,
};

export default withStyles(style)(LocationModal);
